/**
 * Default Work Type is chosen from Salesforce describe picklist values, not hardcoded as the saved value.
 * We match by label/value text; the form stores the picklist API `value` from the matched row.
 */

const PREFERRED_WORK_TYPE_LABELS = [
  "Independent Contractor - Project Based",
  "Independent Contractor – Project Based", // en dash
];

function normalizePicklistText(s) {
  if (s == null) return "";
  return String(s)
    .trim()
    .replace(/\u2013/g, "-")
    .replace(/\s+/g, " ")
    .toLowerCase();
}

/**
 * @param {Array<{ label: string, value: string }>} picklistOptions - active values from Salesforce Work_Type__c describe
 * @returns {string} picklist `value` to store in the form, or "" if not loaded / no matching option
 */
export function getPreferredDefaultWorkTypeValue(picklistOptions) {
  if (!Array.isArray(picklistOptions) || picklistOptions.length === 0) {
    return "";
  }

  const candidates = PREFERRED_WORK_TYPE_LABELS.map(normalizePicklistText).filter(
    Boolean,
  );

  for (const opt of picklistOptions) {
    const nv = normalizePicklistText(opt.value);
    const nl = normalizePicklistText(opt.label);
    for (const c of candidates) {
      if (c === nv || c === nl) {
        return opt.value;
      }
    }
  }

  for (const opt of picklistOptions) {
    const nl = normalizePicklistText(opt.label);
    const nv = normalizePicklistText(opt.value);
    const blob = `${nl} ${nv}`;
    if (
      blob.includes("independent contractor") &&
      blob.includes("project based")
    ) {
      return opt.value;
    }
  }

  return "";
}
